import React from 'react';
import styles from './Badge.module.scss'

interface BadgeProps {
    text: string;
    state: string;
}

const Badge: React.FC<BadgeProps> = ({text , state }) => {
    const getState = (state: string) => {
        switch (state) {
            case "Por Enviar":
            case "Pendiente":
            case "En Proceso":
                return styles.porEnviar
            case "Enviada":
            case "Enviado a Bodega":
            case "Enviado":
            case "Enviado a Picking":
            case "Enviado a Sanitización I":
            case "Enviado a Sanitización II":
            case "Enviado a Pre-elaboración":
            case "Enviado a Producción":
            case "Enviado a Post-elaboración":
            case "Enviado a Etiquetado":
            case "Enviado a Validación":
            case "Enviado a Liberación":
            case "Enviado a Facturación":
            case "Enviado a SAP":
                return styles.enviada
            case "En Ruta":
            case "Aprobado":
                return styles.enRuta
            case "Anulada":
            case "Suspendido":
                return styles.anulada
            case "Vencida":
                return styles.vencida
            case "Envío Parcial":
                return styles.envioParcial
            default:
                return styles.default
        }
    }
    return (
        <div className={`${styles.tappsBadge} ${getState(state)}`} >
            { text  }
        </div>
    );
};

export default Badge;